
  export const ESTADOESTIMACIONS_RECEIVED = "ESTADOESTIMACIONS_RECEIVED";
  export const SET_ESTADOESTIMACION = "SET_ESTADOESTIMACION";
  export const CREATE_ESTADOESTIMACION = "CREATE_ESTADOESTIMACION";
  export const SET_PROPERTY_ESTADOESTIMACION = "SET_PROPERTY_ESTADOESTIMACION";
  